export const money_wallet = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 511.999 511.999" style="enable-background:new 0 0 511.999 511.999;" xml:space="preserve">
<g>
<g>
   <circle cx="333.027" cy="66.204" r="66.204"/>
</g>
</g>
<g>
<g>
   <path d="M182.511,75.18c-36.564,0-66.204,29.64-66.204,66.204c0,2.809,0.195,5.571,0.535,8.288H248.18
       c0.339-2.716,0.535-5.479,0.535-8.288C248.715,104.821,219.075,75.18,182.511,75.18z"/>
</g>
</g>
<g>
<g>
   <path d="M312.939,260.084h142.506v-54.759c0-13.46-10.912-24.37-24.37-24.37H46.553c-13.46,0-24.37,10.912-24.37,24.37v282.304
       c0,13.46,10.91,24.37,24.37,24.37h384.522c13.46,0,24.37-10.911,24.37-24.37V432.87H312.939
       c-29.357,0-53.242-23.884-53.242-53.242v-66.302C259.696,283.968,283.58,260.084,312.939,260.084z"/>
</g>
</g>
<g>
<g>
   <path d="M469.851,293.361H312.939c-11.027,0-19.965,8.938-19.965,19.965v66.302c0,11.027,8.938,19.965,19.965,19.965h156.912
       c11.027,0,19.965-8.938,19.965-19.965v-66.302C489.816,302.299,480.876,293.361,469.851,293.361z M345.968,369.912
       c-12.943,0-23.435-10.492-23.435-23.435c0-12.943,10.492-23.435,23.435-23.435s23.435,10.492,23.435,23.435
       C369.403,359.42,358.911,369.912,345.968,369.912z"/>
</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
`;